module.exports = __webpack_public_path__ + "img/vignettes-asso_0005_les-amis-de-latelier.97ced01f.jpg";